<template>
  <main class="blog">
    <div class="header">
      <b-container class="content" fluid="xs">
        <b-row>
          <b-col>
            <h3 class="title">SNKR BLOG</h3>
            <h1 class="article">Meet the Team Behind the Air Jordan XXXVI</h1>
            <p class="date">September 7 2021</p>
            <div class="social-buttons">
              <p class="share-txt">Share</p>
              <b-link v-for="lnk in share" :key="lnk.id" class="blnk">
                <img :src="lnk.img" :alt="lnk.alt" :class="'img-share-' + lnk.alt" />
              </b-link>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="banner-container">
              <img :src="imgBanner" alt="banner" class="img-banner" />
              <img :src="imgBannerFrame" alt="banner" class="img-banner-frame" />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p class="desc">
              Hustling is endemic in Sneaker Culture. Let me say that again for the folks in the
              back: Hustling is, has, and always will be a part of Sneaker Culture. The hunt for
              your next pair used to even be fun, something you'd look forward to.<br /><br />
              That muse unified teams of design specialists across the brand as they perfected the
              many definitions of the word. The Air Jordan XXXVI's new features a jacquard
              leno-weave upper, a full-length Zoom Air Strobel unit that's double-stacked with a
              forefoot unit, a refined plate system come from experts at Jordan Brand combining
              their specialties to make the best basketball shoe in the world.<br /><br />
              "We want those who love the brand to see something that's always been a part of our
              design legacy: the power of teamwork that goes on between a core group of folks to
              create product excellence," says Martin Lotti, VP, Jordan Brand Design. "Jordan Brand
              is inspired by one man, but ifs carried into the future by many, many people who are
              experts in their field."<br /><br />
              By exploring three aspects of light, the Air Jordan XXXVI highlights the kind of
              collaborative work across Jordan Brand teams that leads the way for the next
              generation of players.
            </p>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="max-85">
        <b-row>
          <b-col>
            <img :src="jordanShoe" alt="jordan shoe" class="img-jordan-shoe" />
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid="xs">
        <b-row>
          <b-col>
            <p class="desc">
              The Air Jordan XXXVI features a jacquard leno-weave material that composes the upper.
              Lightweight but also strong, the material bends and contours to provide support where
              it's needed most. <br /><br />
              Not only does the material help make a lightweight shoe for playing, the breathable
              leno-weave presents a see-through aesthetic that allows light and colors to shine
              through. <br />
              <br />
              "Within the basketball landscape, we wanted to create a new language for light," says
              Jacqueline Lefferts, Jordan Brand Lead Materials Designer. "We asked ourselves, What
              does light look like? It's a product of the upper's weight, but it's also a trait of
              the upper itself in that light is a defining quality." <br /><br />
              The Air Jordan XXXVI cushioning set-up is the most Zoom Air coverage that Jordan Brand
              has put into a signature shoe. A full-length Zoom Air Strobel unit is stitched
              directly to the upper, sitting above another forefoot Zoom Air unit for an extra burst
              of responsiveness. The multi-directional traction pattern is the ideal base to
              initiate that quickness, change of direction and control.<br /><br />
              "One trend we noticed in the basketball market is how lightweight is typically
              described as a performance feature, which has been heavily marketed as ball handling
              and foot-to-court movement. All that is a fundamental part of the game, but the
              origins of the Jordan Brand were about tapping into the time off the floor, the
              hangtime, the flight," says Chad Troyer, Jordan Brand Senior PLM. "In bringing in the
              Zoom Strobel and adding another Zoom unit beneath that, we were working toward that
              'pop' for players so they can get of the floor quickly."
            </p>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="max-85">
        <b-row>
          <b-col>
            <ul>
              <li>Tags:</li>
              <li v-for="tag in tags" :key="tag.id">
                <b-link :to="tag.path">
                  {{ tag.name }}
                </b-link>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
      <hr class="blog-divider" />
      <b-container fluid="sm" class="more-blog">
        <b-row>
          <b-col>
            <b-card-group deck>
              <b-card
                v-for="card in cards"
                :key="card.id"
                :title="card.title"
                :img-src="card.img"
                :img-alt="card.title"
                img-top
              >
                <b-card-text>
                  {{ card.desc }}
                </b-card-text>
              </b-card>
            </b-card-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button class="btn-more-blog">
              <img
                src="@/assets/rebrand/blog/more-blog.png"
                alt="more blog"
                class="img-more-blog"
              />
            </b-button>
          </b-col>
        </b-row>
        <img src="@/assets/rebrand/blog/spider-web.png" alt="grid" class="spider-web" />
      </b-container>
      <b-container class="future-hustlers">
        <b-row>
          <b-col>
            <b-link href="https://discord.gg/snkrhud" target="_blank" class="btn-join-now"></b-link>
          </b-col>
        </b-row>
        <img
          src="@/assets/rebrand/blog/future-hustlers-elements.png"
          alt="future hustlers elements"
          class="img-future-hustlers-elements"
        />
        <img
          src="@/assets/rebrand/blog/futurehustlers.png"
          alt="future hustlers"
          class="img-future-hustlers"
        />
      </b-container>
      <img src="@/assets/rebrand/blog/grid.png" alt="grid" class="grid" />
    </div>
  </main>
</template>
<script>
export default {
  name: 'AirJordanXxxvi',
  data() {
    return {
      share: [
        {
          id: 0,
          img: require('../../assets/rebrand/blog/facebook.png'),
          alt: 'facebook',
        },
        {
          id: 1,
          img: require('../../assets/rebrand/blog/twitter.png'),
          alt: 'twitter',
        },
        {
          id: 2,
          img: require('../../assets/rebrand/blog/instagram.png'),
          alt: 'instagram',
        },
        {
          id: 3,
          img: require('../../assets/rebrand/blog/email.png'),
          alt: 'email',
        },
        {
          id: 4,
          img: require('../../assets/rebrand/blog/link.png'),
          alt: 'link',
        },
      ],
      tags: [
        {
          id: 0,
          path: '/sport-research',
          name: 'Sport Research',
        },
        {
          id: 1,
          path: '/trending',
          name: 'Trending',
        },
        {
          id: 2,
          path: '/air-jordan',
          name: 'Air Jordan',
        },
        {
          id: 3,
          path: '/innovation',
          name: 'Innovation',
        },
      ],
      cards: [
        {
          id: 0,
          title: 'Meet the NYC Adidas Family',
          img: require('../../assets/rebrand/blog/adidas-family.png'),
          desc:
            'Colors that once faded into the background have recently re-emerged, on trend and elevated. From apparel to footwear and everything in between, neutrals and earth tones have become the new canvas for personal expression. And this inspired an idea.',
        },
        {
          id: 1,
          title: 'Why Adizero is the key to unlocking your fast ',
          img: require('../../assets/rebrand/blog/adizero.png'),
          desc:
            "adizero—the pacemaker in performance racing, empowering every runner who's ready to be faster. ",
        },
        {
          id: 2,
          title: 'The Nike Rawdacious Colorway Celebrates the Unity of Sport ',
          img: require('../../assets/rebrand/blog/rawdacious.png'),
          desc:
            "Nike's Rawdacious colorway palette for Tokyo — a combination of white as a primary, with components of pink blast, total orange and bright crimson — is another example of how Nike uses color to imbue deep cultural, psychological and emotional value in its footwear. ",
        },
        {
          id: 3,
          title: 'Meet the NYC Adidas Family',
          img: require('../../assets/rebrand/blog/shoe-bottom.png'),
          desc:
            'Colors that once faded into the background have recently re-emerged, on trend and elevated. From apparel to footwear and everything in between, neutrals and earth tones have become the new canvas for personal expression. And this inspired an idea.',
        },
        {
          id: 4,
          title: 'Why Adizero is the key to unlocking your fast ',
          img: require('../../assets/rebrand/blog/swimming.png'),
          desc:
            "adizero—the pacemaker in performance racing, empowering every runner who's ready to be faster. ",
        },
        {
          id: 5,
          title: 'The Nike Rawdacious Colorway Celebrates the Unity of Sport ',
          img: require('../../assets/rebrand/blog/turbodrk.png'),
          desc:
            "Nike's Rawdacious colorway palette for Tokyo — a combination of white as a primary, with components of pink blast, total orange and bright crimson — is another example of how Nike uses color to imbue deep cultural, psychological and emotional value in its footwear. ",
        },
        {
          id: 6,
          title: 'Meet the NYC Adidas Family',
          img: require('../../assets/rebrand/blog/hip-hop.png'),
          desc:
            'Colors that once faded into the background have recently re-emerged, on trend and elevated. From apparel to footwear and everything in between, neutrals and earth tones have become the new canvas for personal expression. And this inspired an idea.',
        },
        {
          id: 7,
          title: 'Why Adizero is the key to unlocking your fast ',
          img: require('../../assets/rebrand/blog/friends.png'),
          desc:
            "adizero—the pacemaker in performance racing, empowering every runner who's ready to be faster. ",
        },
        {
          id: 8,
          title: 'The Nike Rawdacious Colorway Celebrates the Unity of Sport ',
          img: require('../../assets/rebrand/blog/sit.png'),
          desc:
            "Nike's Rawdacious colorway palette for Tokyo — a combination of white as a primary, with components of pink blast, total orange and bright crimson — is another example of how Nike uses color to imbue deep cultural, psychological and emotional value in its footwear. ",
        },
      ],
      imgBanner: require('../../assets/rebrand/blog/air-jordan-xxxvi.png'),
      imgBannerFrame: require('../../assets/rebrand/blog/frame-line.png'),
      imgDedStock: require('../../assets/rebrand/blog/ded-stock-card.png'),
      jordanShoe: require('../../assets/rebrand/blog/jordan.png'),
    };
  },
};
</script>
<style lang="scss">
@import "../../assets/styles/blog.scss";
</style>
